export default __webpack_public_path__ + "static/media/delete.013821a9.svg";